let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("bvWQ9")).then(() => parcelRequire('cza5m'));